import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import { ButtonWithIcon } from '@els/els-react--button';
import { TextInput, NumberInput } from '@els/els-react--text-input';
import { Checkbox } from '@els/els-react--checkbox';

import { buildDetailsMapping, featureSwitchGroupLabelMapping, optionsMapping } from './Constants';

import './Dev.scss';

function Dev({ devDetails = {}, syncWSParams, killMySession = () => {}, mockSessionTimeout = () => {}, updateDev = () => {}, saveBEURL }) {
  const { options } = devDetails;

  return (
    <div className="dev-view o-els-flex-layout o-els-flex-layout--wrap@tablet">
      <div className="feature-switch-section u-els-width-1o3 u-els-width-1o1@tablet u-els-padding">
        <div>
          <h1 className="pageTitle">Developer options</h1>
          {Object.keys(buildDetailsMapping)?.map((item) => (
            <div key={item}>
              {buildDetailsMapping[item]}: <code>{devDetails[item]}</code>
            </div>
          ))}
        </div>
        <div className="u-els-margin-top">
          <ButtonWithIcon data-e2e="kill-session-btn" sprite="ChevronRight" iconRight onClick={killMySession} type="warn">
            <span>Kill my session</span>
          </ButtonWithIcon>
          <ButtonWithIcon
            data-e2e="mock-session-timeout-btn"
            sprite="ChevronRight"
            iconRight
            onClick={mockSessionTimeout}
            type="warn"
            className="u-els-margin-left">
            <span>Mock session timeout</span>
          </ButtonWithIcon>
        </div>
        <div className="u-els-margin-top">
          {devDetails.BEURLList &&
            devDetails.BEURLList?.map((item) => (
              <div key={item} className="u-els-margin-top">
                <TextInput
                  data-e2e={`be-url-input-${item}`}
                  value={devDetails.BEURL[item] || ''}
                  label={item}
                  onChange={(e) => updateDev('BEURL', { ...devDetails.BEURL, [item]: e.target.value })}
                />
              </div>
            ))}
          <Checkbox
            data-e2e="websockets-over-cdn-checkbox"
            checked={(devDetails.BEURL && devDetails.BEURL.isWebsocketsOverCDN) || false}
            onChange={() => {
              syncWSParams(!(devDetails.BEURL && devDetails.BEURL.isWebsocketsOverCDN));
            }}
            disabled={devDetails.isProxy}
            label="Connect Websockets over CDN"
            className={`u-els-margin-top ${devDetails.BEURL && devDetails.BEURL.isWebsocketsOverCDN ? 'checked' : 'unchecked'}`}
            aria-checked={!!(devDetails.BEURL && devDetails.BEURL.isWebsocketsOverCDN)}
          />
        </div>
        <div className="u-els-margin-top">
          <ButtonWithIcon
            data-e2e="set-be-url-btn"
            sprite="ChevronRight"
            iconRight
            onClick={() => {
              saveBEURL();
            }}>
            <span>Use as BE URL</span>
          </ButtonWithIcon>
          <ButtonWithIcon
            data-e2e="reset-be-url-btn"
            className="u-els-margin-left"
            sprite="Redo"
            iconRight
            onClick={() => {
              saveBEURL(true);
            }}>
            <span>Reset Default BE URL</span>
          </ButtonWithIcon>
        </div>
        <div>
          {options &&
            Object.keys(featureSwitchGroupLabelMapping)?.map((groupItem) => (
              <div key={groupItem}>
                <h3 className="u-els-margin-top-2x">{featureSwitchGroupLabelMapping[groupItem]}:</h3>
                {optionsMapping[groupItem] &&
                  Object.keys(optionsMapping[groupItem])?.map((item) => {
                    if (optionsMapping[groupItem][item].type === 'checkbox') {
                      return (
                        <Checkbox
                          data-e2e="dev-option-checkbox"
                          key={item}
                          checked={options[item] || false}
                          onChange={() => {
                            updateDev('options', { ...cloneDeep(options), [item]: !options[item] });
                          }}
                          label={optionsMapping[groupItem][item].label}
                          className={`u-els-margin-top ${options[item] ? 'checked' : 'unchecked'}`}
                          aria-checked={!!options[item]}
                        />
                      );
                    }
                    return (
                      <NumberInput
                        data-e2e="dev-option-number-input"
                        className="u-els-margin-top"
                        key={item}
                        label={optionsMapping[groupItem][item].label}
                        value={options[item]}
                        onChange={(e) => updateDev('options', { ...options, [item]: e.target.value })}
                      />
                    );
                  })}
              </div>
            ))}
        </div>
      </div>
      <div className="health-check-section u-els-width-2o3 u-els-width-1o1@tablet u-els-padding">
        <h1 className="pageTitle">Healthcheck response:</h1>
        <pre>{devDetails.healthCheck}</pre>
      </div>
    </div>
  );
}

Dev.propTypes = {
  devDetails: PropTypes.object,
  updateDev: PropTypes.func,
  syncWSParams: PropTypes.func,
  killMySession: PropTypes.func,
  mockSessionTimeout: PropTypes.func,
  saveBEURL: PropTypes.func,
};

export default Dev;
